<template>
  <div class="user">
    <div v-if="facility=='app'" class="app">
      <App />
    </div>
    <div v-else>
      <Pc/>
    </div>
  </div>
</template>

<script>
import App from "./app/index";
import Pc from "./pc/index";

export default {
  components:{
    App,
    Pc
  },
  data(){
    return{
      facility:"",
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style>

</style>